import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { gql, useMutation } from '@apollo/client';
import Typography from '@material-ui/core/Typography';

import AnimatedEllipsis from '../components/AnimatedEllipsis.jsx';

const AUTH_MOBILE_CREDENTIAL = gql`
  mutation authenticateMobileCredential($code: String, $redirectUri: String) {
    authenticateMobileCredential(code: $code, redirectUri: $redirectUri)
  }
`;

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
}));

const MobileCredentialAuthPage = () => {
  const classes = useStyles();
  const [redirect, setRedirect] = useState(false);
  const [pageResult, setPageResult] = useState('');

  const { search } = window.location;
  const params = new URLSearchParams(search);
  const authCode = params.get('code');

  // TODO: Verify state parameter is same

  const authCompleted = () => {
    setPageResult('success');
    setRedirect(true);
  };

  const authError = () => {
    setPageResult('failure');
    setRedirect(true);
  };

  const [authenticate] = useMutation(AUTH_MOBILE_CREDENTIAL, {
    variables: { code: authCode, redirectUri: window.location.href.split('?')[0] }, // TODO: Kinda hacky, improve method
    notifyOnNetworkStatusChange: true,
    onCompleted: authCompleted,
    onError: authError,
  });

  useEffect(() => {
    authenticate();
  }, []);

  return (
    <>
      {!redirect && (
        <div className={classes.root}>
          <Typography>Authenticating</Typography>
          <AnimatedEllipsis />
        </div>
      )}
      {redirect && <Redirect to={`/mobilecredential?result=${pageResult}`} />}
    </>
  );
};

export default MobileCredentialAuthPage;
